import React, { useRef, useEffect } from "react";

export const AudioWaveform = ({ isRecording, isPaused, audioLevel }) => {
  const canvasRef = useRef(null);
  const animationRef = useRef(null);
  const barsRef = useRef([]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();

    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    ctx.scale(dpr, dpr);

    const barCount = 60;
    const barWidth = rect.width / barCount;

    if (barsRef.current.length === 0) {
      barsRef.current = Array(barCount).fill(0).map(() => ({
        height: Math.random() * 20 + 10,
        targetHeight: Math.random() * 20 + 10,
        speed: Math.random() * 2 + 1
      }));
    }

    const animate = () => {
      ctx.clearRect(0, 0, rect.width, rect.height);

      barsRef.current.forEach((bar, index) => {
        if (isRecording && !isPaused) {
          bar.targetHeight = audioLevel * rect.height * 0.7 + Math.random() * 30;
        } else {
          bar.targetHeight = Math.random() * 20 + 10;
        }

        bar.height += (bar.targetHeight - bar.height) * 0.1;

        const x = index * barWidth;
        const y = rect.height / 2 - bar.height / 2;

        const gradient = ctx.createLinearGradient(x, y, x, y + bar.height);
        if (isRecording && !isPaused) {
          gradient.addColorStop(0, '#3B82F6');
          gradient.addColorStop(1, '#1E40AF');
        } else {
          gradient.addColorStop(0, '#27272A');
          gradient.addColorStop(1, '#18181B');
        }

        ctx.fillStyle = gradient;
        ctx.fillRect(x + barWidth * 0.2, y, barWidth * 0.6, bar.height);
      });

      animationRef.current = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isRecording, isPaused, audioLevel]);

  return (
    <div className="waveform-container" data-testid="audio-waveform">
      <canvas ref={canvasRef} className="waveform-canvas" />
    </div>
  );
};

export default AudioWaveform;